import { useEffect, useState } from "react";
import { Package } from "lucide-react";
import { api } from "@/lib/api";
import { Page } from "@/components/Page";

export default function BuyerDashboard() {
  const [orders, setOrders] = useState([]);
  useEffect(() => { api.get("/buyer/orders").then(r => setOrders(r.data)).catch(() => {}); }, []);
  return (
    <Page title="My orders" subtitle="Every order you have placed on the True Vision marketplace.">
      {orders.length ? (
        <div className="admin-table" data-testid="buyer-orders-table">
          <div className="admin-row admin-head"><span>Product</span><span>Total</span><span>Status</span><span>Delivery to</span><span>Placed on</span></div>
          {orders.map(o => (
            <div className="admin-row" key={o.id} data-testid={`buyer-order-${o.id}`}>
              <span>{o.product_name} × {o.quantity}</span>
              <span>₹{Number(o.total).toLocaleString("en-IN")}</span>
              <span className={o.status === "Delivered" ? "pill green" : o.status === "Cancelled" ? "pill red" : "pill amber"}>{o.status}</span>
              <span style={{ whiteSpace: "normal" }}>{o.buyer_address}</span>
              <span>{new Date(o.created_at).toLocaleDateString()}</span>
            </div>
          ))}
        </div>
      ) : (
        <div className="empty-state" data-testid="buyer-no-orders">
          <Package size={26} />
          <h3>You haven't placed any orders yet</h3>
          <p>Explore the marketplace and buy directly from GI-authorised makers.</p>
        </div>
      )}
    </Page>
  );
}
